module.exports = __webpack_public_path__ + "img/1521303644.24aac2ac.jpg";